module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/4-93e1204aee652a244e2ce849732e62d6.png";